import { arrayOrArray, TApiaSystemMessageObj } from '@apia/util';
import { notify, TNotificationType, uniqueId } from '../defaultNotifier';
import { INotification } from '../types';
import { TMessage, TNotificationMessage } from './types';

/**
 * Devuelve un array de notificaciones a partir de
 * una respuesta de Apia.
 */
export const getNotificationMessageObj = (
  data: TApiaSystemMessageObj,
): INotification<TNotificationType>[] | null => {
  const notifications: INotification<TNotificationType>[] = [];
  if (data?.sysMessages?.message) {
    notifications.push(
      ...parseServerNotification(data.sysMessages.message, 'warning'),
    );
  }
  if (data?.sysExceptions) {
    notifications.push(
      ...parseServerNotification(data.sysExceptions.exception, 'danger'),
    );
  }
  if (data?.exceptions?.exception) {
    notifications.push(
      ...parseServerNotification(data.exceptions.exception, 'danger'),
    );
  }
  if (notifications.length > 0) return notifications;
  return null;
};

function parseServerNotificationType(type: string): TNotificationType {
  switch (type) {
    case '1':
      return 'success';
    case '2':
      return 'warning';
    case '3':
      return 'danger';
    default:
      return 'warning';
  }
}

/**
 * Toma un objeto de notificación de servidor y lo convierte a un
 * objeto de notificación de cliente.
 */
export const parseServerNotification = (
  serverNotification: TMessage | TMessage[],
  type: TNotificationType,
): INotification<TNotificationType>[] => {
  const messages = arrayOrArray(serverNotification);
  return messages.map((current) => {
    const returnNotification: INotification<TNotificationType> = {
      message: current.text,
      trace: current.content,
      title: current.title,
      type:
        current.type !== undefined
          ? parseServerNotificationType(current.type)
          : (type as TNotificationType),
      isOpen: true,
      id: uniqueId(),
    };
    return returnNotification;
  });
};

/**
 * Toma un objeto de respuesta de servidor que puede eventualmente
 * tener notificaciones y las pasa al sistema de notificaciones si
 * es que hay alguna.
 */
export const dispatchNotifications = (alert: TNotificationMessage) => {
  if (alert) {
    if (alert.sysMessages?.message)
      parseServerNotification(alert.sysMessages?.message, 'warning').forEach(
        notify,
      );
    if (alert.exceptions?.exception)
      parseServerNotification(alert.exceptions?.exception, 'danger').forEach(
        notify,
      );
    if (alert.sysExceptions?.exception)
      parseServerNotification(alert.sysExceptions?.exception, 'danger').forEach(
        notify,
      );
  }
};

export * from './types';
